var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvRangeAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#D0E0E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8883_30745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5413 8.58301H14.9395C17.7328 8.58301 19.1295 8.58301 19.6597 9.08469C20.118 9.51834 20.3211 10.1572 20.1973 10.7759C20.0542 11.4916 18.9139 12.2981 16.6334 13.9112L12.9076 16.5465C10.6271 18.1596 9.48683 18.9661 9.34369 19.6818C9.21996 20.3005 9.42306 20.9393 9.88134 21.373C10.4115 21.8747 11.8082 21.8747 14.6015 21.8747H15.458M11.333 8.58301C11.333 10.1018 10.1018 11.333 8.58301 11.333C7.06422 11.333 5.83301 10.1018 5.83301 8.58301C5.83301 7.06422 7.06422 5.83301 8.58301 5.83301C10.1018 5.83301 11.333 7.06422 11.333 8.58301ZM24.1663 21.4163C24.1663 22.9351 22.9351 24.1663 21.4163 24.1663C19.8976 24.1663 18.6663 22.9351 18.6663 21.4163C18.6663 19.8976 19.8976 18.6663 21.4163 18.6663C22.9351 18.6663 24.1663 19.8976 24.1663 21.4163Z",
    stroke: "#45748C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8883_30745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvRangeAlert);
export default __webpack_public_path__ + "static/media/evRangeAlert.061cdb59905b61490596920eeee94387.svg";
export { ForwardRef as ReactComponent };